import Button from './Button'
import ConfirmationModal from './ConfirmationModal'

type Props = {
	onStayHere: () => void
	onDiscardChanges: () => void
	name: string
}

function UnsavedChangesModal({ onStayHere, onDiscardChanges, name }: Props) {
	return (
		<ConfirmationModal
			name="UnsavedChangesModal"
			data-testid="UnsavedChangesModal"
			title="You have unsaved changes"
			caption={`Changes made in ${name} will be lost if you continue. Are you sure you want to discard them?`}
			hideModal={onStayHere}
		>
			<Button kind="secondary" onClick={onStayHere} mediumDesktop>
				Stay here
			</Button>
			<Button kind="destructive" onClick={onDiscardChanges} mediumDesktop>
				Discard changes
			</Button>
		</ConfirmationModal>
	)
}

export default UnsavedChangesModal
